// デモ（TOPページ埋め込み）で共通利用する定数。
export const DEMO_SIGNUP_PATH = "/users/sign_up?from=demo";

// 本登録への遷移。モーダルの確定ボタンとフォーム下のCTAで共通利用する。
export const goToDemoSignup = () => {
  window.location.href = DEMO_SIGNUP_PATH;
};

// この index 以降のステップはデモではロック（本登録が必要）。
// ラベルとセットで更新すること。
export const DEMO_LOCKED_FROM_STEP = 9;
export const DEMO_LOCKED_FROM_STEP_LABEL = "⑩";

// 指定 index のステップがデモでロックされているか。
// demo=false（本番の作成画面）では常に false。
export const isDemoStepLocked = (demo, index) =>
  demo && index >= DEMO_LOCKED_FROM_STEP;
